import React from 'react';
import { Container } from '@material-ui/core';
import { Pie } from 'react-chartjs-2';

const CPie = () => {
  return (
    <>
      <Container maxWidth="xs">
        <Pie data={[]} />
      </Container>
    </>
  );
};

export default CPie;
